import * as types from './actionType';
import {
  getProperty,
  submitFormData,
  createContentVersion,
  getCoverageAmount,
  emailVerify,
} from '../apis/formAPIs';
import { getErrorMessage } from 'utils/getErrorMessage';

export const setDataAction = (data) => ({
  type: types.SET_DATA,
  payload: data,
});

export const setPropertyAction = (data) => ({
  type: types.SET_PROPERTY,
  payload: data,
});

export const setSuccessAction = (data) => ({
  type: types.SET_SUCCESS,
  payload: data,
});

export const setErrorAction = (data) => ({
  type: types.SET_ERR,
  payload: getErrorMessage(data),
});

export const searchPropertyAction = (data) => {
  return (dispatch) => {
    dispatch(setSuccessAction('pending'));
    getProperty(data)
      .then((res) => {
        dispatch(setPropertyAction(res));
        dispatch(setSuccessAction('success'));
        dispatch(setErrorAction(''));
      })
      .catch((err) => {
        dispatch(setErrorAction(err?.response?.data || err));
      });
  };
};

export const setCoverageAmount = (data) => ({
  type: types.SET_COVERAGEAMOUNT,
  payload: data,
});

export const getCoverageAmountAction = (data) => {
  return (dispatch) => {
    getCoverageAmount(data)
      .then((res) => {
        dispatch(setCoverageAmount(res.data));
      })
      .catch((err) => {
        dispatch(setErrorAction(err?.response?.data || err));
      });
  };
};

export const submitFormAction = (data) => {
  return async (dispatch) => {
    try {
      dispatch(setErrorAction(''));
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          ...data,
          birthDate: new Date(data.birthDate).toISOString().slice(0, 10),
          moveInDate: new Date(data.moveInDate).toISOString().slice(0, 10),
          employmentStartDate:
            data.employmentStartDate &&
            new Date(data.employmentStartDate).toISOString().slice(0, 10),
        }),
      );

      try {
        const res = await submitFormData(formData);
        dispatch(setErrorAction(''));
        dispatch(setSuccessAction(res));
      } catch (error) {
        dispatch(setErrorAction(error?.response?.data || error));
      }
    } catch (error) {
      dispatch(setErrorAction(error));
    }
  };
};
